<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit repair priority') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deletePriorityModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/repair-priorities">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updatePriority">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Repair priority details') }}
              </h3>
              <p class="form-description-text">{{ $t('Repair priority details and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="priority.name" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="value">{{ $t('Value') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Value')" class="form-input" id="value" min="0" required type="number" v-model="priority.value" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="extra_charge">{{ $t('Extra charge') }}</label>
                  <div class="pt-1">
                    <input
                      :placeholder="$t('Extra charge')"
                      class="form-input"
                      id="extra_charge"
                      min="0"
                      required
                      type="number"
                      v-model="priority.extra_charge"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repair-priorities">{{ $t('Close') }}</router-link>
              <button class="btn btn-green shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <repair-priority-delete-model :show="deletePriorityModal" @cancelled="deletePriorityModal = false" @confirmed="deleteRepairPriority">
      <template #title>{{ $t('Delete repair priority') }}</template>
      {{ $t('Are you sure you want to delete the repair priority ?') }}
      {{ $t('All data will be permanently removed') }}.
    </repair-priority-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('New repair priority'),
    };
  },
  components: {
    RepairPriorityDeleteModel: confirmationModel,
  },
  data() {
    return {
      loading: true,
      deletePriorityModal: false,
      priority: {
        name: null,
        value: null,
        extra_charge: null,
      },
    };
  },
  mounted() {
    this.getPriority();
  },
  methods: {
    deleteRepairPriority() {
      axios
        .delete(route('repair-priorities.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/repair-priorities');
        })
        .catch(() => {
          this.deletePriorityModal = false;
        });
    },
    updatePriority() {
      this.loading = true;
      axios
        .put(route('repair-priorities.update', this.$route.params.id), this.priority)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getPriority() {
      this.loading = true;
      axios
        .get(route('repair-priorities.show', this.$route.params.id))
        .then((response) => {
          this.priority = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
